import React from "react";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import DirectionsBoatOutlinedIcon from "@mui/icons-material/DirectionsBoatOutlined";

/**
 * Central icon resolver. Given an iconType string, returns the correct
 * MUI icon element with appropriate size styling.
 */
const DashIcon = ({ type, size = 20, color }) => {
  const style = { fontSize: size, color: color || "inherit" };

  switch (type) {
    case "quotation":
      return <DescriptionOutlinedIcon style={style} />;
    case "briefcase":
      return <WorkOutlineIcon style={style} />;
    case "truck":
      return <LocalShippingOutlinedIcon style={style} />;
    case "customs":
    case "customs-user":
      return <PersonOutlineIcon style={style} />;
    case "warning":
      return <WarningAmberOutlinedIcon style={style} />;
    case "calendar":
      return <CalendarTodayOutlinedIcon style={style} />;
    case "check-circle":
    case "customs-done":
    case "delivered":
    case "cleared":
    case "ready-close":
      return <CheckCircleOutlineIcon style={style} />;
    case "airplane":
      return <FlightOutlinedIcon style={style} />;
    case "location":
    case "arriving":
      return <LocationOnOutlinedIcon style={style} />;
    case "document":
    case "missing-doc":
      return <AssignmentOutlinedIcon style={style} />;
    case "booking":
    case "documents":
      return <InventoryOutlinedIcon style={style} />;
    case "pickup":
    case "truck-pending":
      return <LocalShippingOutlinedIcon style={style} />;
    case "transit":
      return <DirectionsBoatOutlinedIcon style={style} />;
    case "delayed":
      return <WarningAmberOutlinedIcon style={style} />;
    case "pending":
    case "alert-triangle":
      return <WarningAmberOutlinedIcon style={style} />;
    case "assessment":
      return <SearchOutlinedIcon style={style} />;
    case "query":
      return <HelpOutlineIcon style={style} />;
    case "inspection":
      return <InboxOutlinedIcon style={style} />;
    case "expiring":
      return <CalendarTodayOutlinedIcon style={style} />;
    case "delivery":
      return <CheckCircleOutlineIcon style={style} />;
    case "alert-sla":
      return <ArrowForwardOutlinedIcon style={style} />;
    default:
      return <DescriptionOutlinedIcon style={style} />;
  }
};

export default DashIcon;
